import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/learn/dbt/$module")({
  component: () => <Outlet />,
});
